module.exports = __webpack_public_path__ + "static/why-sourcing-with-shipkoo-65dcdf51386e31ad2c9bd32a4cd98df1.png";